import React, { useLayoutEffect, useState } from "react";
import DefaultIcon from "../../../assets/aws-icons/aws.svg";
import { getIconKey } from "../manageProvision/utils";

const SvgIcon = ({ icon }) => {
  const [IconComponent, setIconComponent] = useState(null);

  useLayoutEffect(() => {
    const iconName = getIconKey(icon);
    import(`../../../assets/aws-icons/${iconName}.svg`)
      .then((module) => {
        setIconComponent(() => module.default);
      })
      .catch((error) => {
        console.error(`No icon found for ${iconName}, using default icon.`);
        setIconComponent(() => DefaultIcon);
      });
  }, [icon]);

  if (!IconComponent) {
    return <img src={DefaultIcon} alt="default icon" />;
  }

  return <img src={IconComponent} alt={`${icon} icon`} />;
};

export default SvgIcon;
